import React, { useCallback, useEffect, useState } from 'react';
import LoadingIndicator from './LoadingIndicator';

const graphqlUrl = process.env.REACT_APP_GRAPHQL_URI || 'http://localhost:3000/graphql';
const statusUrl = new URL(
    '/application-status',
    new URL(graphqlUrl, typeof window === 'undefined' ? 'http://localhost:3000' : window.location.origin),
).toString();

const WebMaintenanceGate = ({ bypass = false, children }) => {
    const [checking, setChecking] = useState(true);
    const [maintenanceEnabled, setMaintenanceEnabled] = useState(false);

    const checkStatus = useCallback(async () => {
        try {
            const response = await fetch(statusUrl, { headers: { Accept: 'application/json' }, cache: 'no-store' });
            if (!response.ok) throw new Error(`Application status returned HTTP ${response.status}`);
            const status = await response.json();
            setMaintenanceEnabled(status.webMaintenanceEnabled === true);
        } catch (error) {
            // Fail open so a temporary status-check outage does not take the site down.
            console.warn('Unable to check web maintenance status', error);
        } finally {
            setChecking(false);
        }
    }, []);

    useEffect(() => {
        checkStatus();
        const interval = setInterval(checkStatus, 10000);
        const checkWhenVisible = () => {
            if (document.visibilityState === 'visible') checkStatus();
        };
        window.addEventListener('focus', checkStatus);
        document.addEventListener('visibilitychange', checkWhenVisible);
        return () => {
            clearInterval(interval);
            window.removeEventListener('focus', checkStatus);
            document.removeEventListener('visibilitychange', checkWhenVisible);
        };
    }, [checkStatus]);

    if (checking && !bypass) return <LoadingIndicator />;
    if (!bypass && maintenanceEnabled) {
        return <main className="maintenance-screen" role="main">
            <div className="maintenance-card">
                <div className="maintenance-mark" aria-hidden="true">B</div>
                <p className="maintenance-eyebrow">A short intermission</p>
                <h1>We’ll be back shortly</h1>
                <p>BoozeOn is undergoing scheduled maintenance. Our team is working to bring the experience back online.</p>
                <button type="button" onClick={checkStatus}>Check again</button>
            </div>
        </main>;
    }
    return children;
};

export default WebMaintenanceGate;
